import React from "react";
import {
  FlatActionList,
  FlatActionListItem,
  Page,
} from "@towersystems/roam-common-native";
import { Feather } from "@expo/vector-icons";
import { StackScreenProps } from "@react-navigation/stack";
import { useTranslation } from "react-i18next";
import { AccountCountryType } from "@towersystems/roam-common/lib/generated-types";
import { useVendorControllerProvider } from "../../../../utilities/vendor";

const options = [
  {
    label: "Australia",
    value: AccountCountryType.AUSTRALIA,
    description:
      "Your business is based in Australia. Relevant information will be displayed such as ABN, GST, etc.",
  },
  {
    label: "New Zealand",
    value: AccountCountryType.NEW_ZEALAND,
    description: "Your business is based in New Zealand.",
  },
];

export type SelectAccountCountryTypeScreenScreenProps = StackScreenProps<
  any,
  "SelectAccountCountryTypeScreenScreen"
>;

export const SelectAccountCountryTypeScreenScreen = ({
  navigation,
}: SelectAccountCountryTypeScreenScreenProps) => {
  const { t } = useTranslation("settings");
  const { currentVendor, updateVendorDetails } = useVendorControllerProvider();

  const handleSelect = async (countryType: string) => {
    if (!currentVendor) return;
    try {
      await updateVendorDetails({
        countryType: countryType as AccountCountryType,
      });
      navigation.goBack();
    } catch (error) {
      console.error("Failed to update vendor details:", error);
    }
  };

  if (!currentVendor) {
    return null; // or handle loading state
  }

  const items: FlatActionListItem[] = React.useMemo(() => {
    return options.map((option) => ({
      id: option.value,
      key: option.value,
      title: option.label,
      subTitle: option.description,
      icon: <Feather name="check" size={24} color="black" />,
      onPress: () => {
        handleSelect(option.value);
      },
      selected: currentVendor.countryType === option.value,
    }));
  }, [currentVendor.countryType]);

  return (
    <Page title={t("modal_select_account_country_type_title")}>
      <FlatActionList items={items} />
    </Page>
  );
};
